import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

import { MASTERY_LEVEL_TO_LABEL_MAPPER } from './constants';
import { MASTERY_LEVELS } from './constants';

export const shouldDisablePublish = ({ status, overallResponseStatus }) => {
  if (
    MASTERY_LEVEL_TO_LABEL_MAPPER[overallResponseStatus] ===
    MASTERY_LEVELS.NEEDS_REVIEW
  )
    return true;
  if (
    status === 'complete' &&
    overallResponseStatus === SIGNIFICANT_ERRORS_IN_WORK
  )
    return false;
  if (
    status === 'revise' &&
    [WORK_IS_COMPLETE_AND_CORRECT, GENERAL_CONCEPTUAL_UNDERSTANDING].includes(
      overallResponseStatus
    )
  )
    return false;
  if (status === 'complete' || status === 'revise') return true;

  return false;
};
